import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import TwoFactorAuthenticationSection from 'components/settings/profile/TwoFactorAuthenticationSection';

export default function EntryPoint({ contextProps, wrappedProps }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppWrapper {...contextProps}>
        <TwoFactorAuthenticationSection {...wrappedProps} />
      </AppWrapper>
    </QueryClientProvider>
  );
}

EntryPoint.propTypes = {
  wrappedProps: PropTypes.shape({
    initialEnabledAt: PropTypes.string,
  }).isRequired,
};
